import { request } from 'src/utils/request';
// import { stringify } from 'qs';

// 获取区划管理列表
export function getDistrictsList (params) {
  return request('/api/zlbuser/tenant/list', {
    params,
  });
}

// 获取区划负责人列表
export function getDistrictsManageList (params) {
  return request('/api/zlbuser/tenant/manager', {
    params,
  });
}

// 设置区划负责人
export function setDistrictsManage (data) {
  return request('/api/zlbuser/tenant/manager', {
    data,
    method: 'post'
  });
}
// 批量导出单位
export function bulkExportUnit (params) {
  return request('/api/zlbuser/institution/downCheckResults', {
    responseType:'blob',
    method: 'post',
    data: params,
  });
}
// // 获取省级区划
// export function getProvinceDistrictList (params) {
//   return request('/api/zlbuser/province/district', {
//     params,
//   });
// }

// 分页查询机构下级单位列表
export function getInstitutionList (params) {
  return request('/api/zlbuser/institution/tenant/institution/list', {
    params,
  });
}

// 根据区划code查询费控规则
export function getCostControlRule (params) {
  return request(`/zlb/cost/control/standard/get-by-district/${params.tenantCode}`);
}

// 标签分类查询
export async function getTagTypeList (params) {
  return request('/api/zlbuser/tagtype/list', { params });
}

// 标签查询
export async function getTagList (params) {
  return request('/api/zlbuser/tag/list', { params });
}

// 标签
export async function removeDomainTag (data) {
  return request('/api/zlbuser/tag/removeDomainTag', {
    data,
    method: 'post'
  });
}

// 标签
export async function addDomainTag (data) {
  return request('/api/zlbuser/tag/addDomainTag', {
    data,
    method: 'post'
  });
}

// 区划配置标签
export function submitManageTag (data) {
  return request('/api/zlbuser/tag/updateDomainTag', {
    data,
    method: 'post'
  });
}

// 单位配置标签
export function submitCompanyTag (data) {
  return request('/api/zlbuser/tag/updateBillTag', {
    data,
    method: 'post'
  });
}

// 标签联合查询
export function getTagCombineList (params) {
  return request('/api/zlbuser/tag/tagCombineList', {
    params
  });
}

// 核算系统枚举列表
export function reqAccountingList (params) {
  return request('/zlb/api/archive/accounting/list', {
    params,
  });
}

// 获取区划下核算系统详情
export function reqAccountingDetail (params) {
  return request('/zlb/api/archive/accounting/detail', {
    params,
  });
}

// 保存更新区划下的核算系统
export function reqAccountingSaveOrUpdate (data) {
  return request('/zlb/api/archive/accounting/save-or-update', {
    data,
    method: 'post'
  });
}
